import { render, staticRenderFns } from "./verticalMenu.vue?vue&type=template&id=33ed8045&scoped=true"
import script from "./verticalMenu.vue?vue&type=script&lang=js"
export * from "./verticalMenu.vue?vue&type=script&lang=js"
import style0 from "./verticalMenu.vue?vue&type=style&index=0&id=33ed8045&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ed8045",
  null
  
)

export default component.exports